<div class="grid sm:grid-cols-4 gap-6 w-full max-w-200" data-tour-id="typ-numerowania">
    <div class="sm:col-span-2">
        <div class="flex-auto cursor-pointer">
            <div class="leading-6 font-semibold">Typ numerowania</div>
            <div class="text-md text-secondary">Numery mogą być resetowane w każdym miesiącu, bądź co roku. </div>
        </div>
    </div>
    <div class="sm:col-span-2">
        <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
            <mat-select [formControl]="control" matInput>
                <mat-option [disabled]="isDisabled(numberingType.id)" [value]="numberingType.id" *ngFor="let numberingType of numberingTypes">
                    {{numberingType.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>